import type { IStopArea } from '../../../models/stop-area.model';
import { StopPointApiModel } from './stop-point.api-model';
import { TariffZoneApiModel } from './tariff-zone.api-model';

export class StopAreaApiModel {
  public static mapToBusinessModel(apiModel: StopAreaApiModel): IStopArea {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      municipalityName: apiModel.municipalityName,
      tariffZone1: TariffZoneApiModel.mapToBusinessModel(apiModel.tariffZone1),
      tariffZone2: TariffZoneApiModel.mapToBusinessModel(apiModel.tariffZone2),
      stopPoints: apiModel.stopPoints ? apiModel.stopPoints.map(StopPointApiModel.mapToBusinessModel) : [],
    };
  }

  public gid!: string;
  public name!: string;
  public latitude?: number;
  public longitude?: number;
  public municipalityName?: string;
  public tariffZone1?: TariffZoneApiModel;
  public tariffZone2?: TariffZoneApiModel;
  public stopPoints?: StopPointApiModel[];
}
